<template>
  <CoreLayout>
    <div
      class="mb-5"
      :class="{ 'container': !isMobile }"
    >
      <InfoLayout
        :current-path="reverseFullL10N({ name: 'document', args: { language: urlLang } })"
        :is-policy="false"
        class="pt-6"
      >
        <template #title>
          {{ pageTitle }}
        </template>
        <template #content>
          <MainContent :context="context" />
        </template>
      </InfoLayout>
    </div>
  </CoreLayout>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import I18NextVue from 'i18next'
import { CoreLayout } from 'src/layouts'
import { useContextStore, useURLStore } from 'src/store'
import InfoLayout from 'src/layouts/info-pages/InfoLayout.vue'
import MainContent from 'src/components/pages/info/document/index/components/MainContent/MainContent.vue'
import type { DocumentPageContext } from 'src/components/pages/info/document/index/types'

const { t, language } = I18NextVue
const options = { ns: language }

const { context: rawContext, urlLang } = useContextStore()
const context = rawContext as DocumentPageContext
const isMobile = computed(() => context.flavour === 'mobile')
const { reverseFullL10N } = useURLStore()

const pageTitle = computed(() => (
  context.request.country.is_russia
    ? t('Редакция и юрлицо', options)
    : t('Реквизиты компании', options)
))
</script>
